import { useSafeState } from '#hooks';
import { FC } from 'react';
import { AllowListTable } from './allowListTable.component';

export const AllowListDropDown: FC = () => {

    const [isExpandedBubble, setIsExpandedBubble] = useSafeState<boolean>(false)
    const src = isExpandedBubble ? '/images/expand.png' : 'images/contract.png';

    return <div className='main-dashboard-container pd-m mt-s'>
        <div className='three-columns-expand-two' onClick={() => setIsExpandedBubble(!isExpandedBubble)}>
            <h3>Allowed Users</h3>
            <div />
            <img src={src} alt="arrow" className='expand-contract-esim vertical-align ml-l' />
        </div>
        {isExpandedBubble && <AllowListTable />}
    </div>
}